<template>
  <section id="user-form">
    <p class="step-info">PASSO 1 DE 3</p>
    <h3 class="step-description">Crie uma senha para iniciar sua assinatura</h3>

    <form @submit="doRegister()" @submit.prevent>
      <v-text-field
        label="Email"
        type="email"
        required
        outlined
        v-model="register.email"
      ></v-text-field>
      <v-text-field
        label="Senha"
        type="password"
        required
        outlined
        minlength="6"
        v-model="register.password"
      ></v-text-field>

      <v-btn block large color="success" type="submit" :loading="isCreating"
        >Continuar</v-btn
      >
    </form>
  </section>
</template>


<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  data() {
    return {
      isCreating: false,
      register: {
        email: "",
        password: "",
      },
    };
  },

  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) this.$router.push("/criar-conta/plans");
    });
  },

  methods: {
    async doRegister() {
      try {
        this.$data.isCreating = true;
        await firebase
          .auth()
          .createUserWithEmailAndPassword(
            this.$data.register.email,
            this.$data.register.password
          );
        this.$data.isCreating = false;
      } catch (e) {
        if (e.code === "auth/email-already-in-use") {
          try {
            await firebase
              .auth()
              .signInWithEmailAndPassword(
                this.$data.register.email,
                this.$data.register.password
              );
          } catch (e2) {
            alert('Não foi possível acessar a conta! Certifique-se de que informou corretamente as credenciais');
          }

          return;
        }

        alert("Houve um erro ao criar a conta!");
        this.$data.isCreating = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#user-form {
  padding-top: 80px;
  padding-bottom: 80px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 30vw;

  .step-info {
    width: 100%;
    margin: 0;
  }

  .step-description {
    margin: 0;
  }

  form {
    width: 100%;
    margin-top: 30px;

    button {
      width: 100%;
      height: 45px;
      font-weight: normal;
      font-size: 16px;
    }
  }
}
</style>